import { FormattedMessage } from 'react-intl';

import { LabelM, Title3 } from '@sorare/core/src/atoms/typography';
import Bold from '@sorare/core/src/atoms/typography/Bold';
import {
  BadgesStepImage,
  ClubShopInformationDialog,
  CoinsStepImage,
  StepTextList,
  StepWrapper,
  howToGetCoinsMessages,
  howToUseCoinsMessages,
} from '@sorare/core/src/components/clubShop/ClubShopInformationDialog';

type Props = { open: boolean; onClose: () => void };
const OnboardingDialog = ({ open, onClose }: Props) => {
  return (
    <ClubShopInformationDialog
      open={open}
      steps={[
        <StepWrapper key="step1">
          <CoinsStepImage />
          <Title3 className="text-enter">
            <FormattedMessage
              id="ClubShop.OnboardingDialog.Step1.Title"
              defaultMessage="Earn Coins Via Competitions & Challenges"
            />
          </Title3>
          <LabelM color="var(--c-neutral-600)">
            <FormattedMessage
              id="ClubShop.OnboardingDialog.Step1.Content1"
              defaultMessage="At the end of every Game Week – Tuesdays and Fridays – you earn Coins based on your Sorare Football teams’ scores (total of the individual competition scores)."
            />
          </LabelM>
          <LabelM color="var(--c-neutral-600)">
            <FormattedMessage {...howToGetCoinsMessages.content2} />
          </LabelM>
        </StepWrapper>,
        <StepWrapper key="step2">
          <BadgesStepImage />
          <Title3 className="text-enter">
            <FormattedMessage {...howToUseCoinsMessages.title} />
          </Title3>
          <LabelM color="var(--c-neutral-600)">
            <FormattedMessage {...howToUseCoinsMessages.content1} />
          </LabelM>
          <StepTextList>
            <li>
              <LabelM color="var(--c-neutral-600)">
                <FormattedMessage
                  id="ClubShop.OnboardingDialog.Step2.Content2"
                  defaultMessage="<Bold>Skins</Bold> – Customize your profile with badges and banners to stand out from the competition."
                  values={{ Bold }}
                />
              </LabelM>
            </li>
            <li>
              <LabelM color="var(--c-neutral-600)">
                <FormattedMessage
                  {...howToUseCoinsMessages.content3}
                  values={{
                    Bold,
                  }}
                />
              </LabelM>
            </li>
            <li>
              <LabelM color="var(--c-neutral-600)">
                <FormattedMessage
                  {...howToUseCoinsMessages.content4}
                  values={{ Bold }}
                />
              </LabelM>
            </li>
          </StepTextList>
        </StepWrapper>,
      ]}
      onClose={onClose}
    />
  );
};

export default OnboardingDialog;
